// Selectores para el estado de lineServices
export const getLineServices = (state) => state.lineServices.services;
export const getLineServicesLoading = (state) => state.lineServices.loading;
export const getLineServicesError = (state) => state.lineServices.error;

// Selectores para el detalle del servicio de línea
export const getLineServiceDetail = (state) => state.lineServices.lineServiceDetail;
export const getLineServiceDetailLoading = (state) => state.lineServices.lineServiceDetailLoading;
export const getLineServiceDetailError = (state) => state.lineServices.lineServiceDetailError;

// Selector para filtrar servicios por categoría
export const getLineServicesByCategory = (state, category) => {
  const services = getLineServices(state);
  if (!category) return services;
  return services.filter(service => service.category === category);
};
